<div class="modal-header">
  <h4 class="modal-title pull-left">{{ popupMessage?.title }}</h4>
  <!-- hide close button if agree is defined and not agreed yet -->
  <button (click)="dismiss()"
          *ngIf="!popupMessage?.agree || !popupMessage?.agree?.required || popupMessage?.agree?.agreed"
          aria-label="Close" class="btn-close" type="button">
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12 content-container">
      <div [innerHTML]="popupMessage?.messageHtml || toHtml(popupMessage?.message)"></div>
    </div>
  </div>
  <div *ngIf="!popupMessage?.agree?.agreed" class="row">
    <div class="col-12 agree-container">
      <div class="agree-box">
        <div class="form-check">
          <input (change)="checkAgree()" [checked]="agreeCheckBox" class="form-check-input" type="checkbox">
        </div>
      </div>
      <div [innerHTML]="popupMessage?.agree?.messageHtml || toHtml(popupMessage?.agree?.message)" class="agree-content">
      </div>
    </div>
  </div>
  <div *ngIf="popupMessage?.agree?.agreed" class="row">
    <div class="col-12 agree-container">
      <div [innerHTML]="popupMessage?.agree?.messageHtml || toHtml(popupMessage?.agree?.message)"
           class="agree-box"></div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <!-- agree -->
  <ng-container *ngIf="popupMessage?.agree && !popupMessage?.agree?.agreed">
    <button (click)="agree(true)" [disabled]="!agreeCheckBox" class="btn btn-dark mr-8px" type="button">AGREE</button>

    <!-- different button title depending on agree required -->
    <button (click)="agree(false)"
            *ngIf="popupMessage?.agree?.required"
            class="btn btn-light" type="button">QUIT
    </button>
    <button (click)="dismiss()"
            *ngIf="!popupMessage?.agree?.required"
            class="btn btn-light" type="button">CLOSE
    </button>
  </ng-container>
  <!-- general -->
  <ng-container *ngIf="!popupMessage?.agree || popupMessage?.agree?.agreed">
    <button (click)="hide()" *ngIf="popupMessage?.hide"
            class="btn btn-dark mr-8px" type="button">
      {{ popupMessage?.hide?.button || 'DO NOT SHOW THIS MESSAGE' }}
    </button>
    <button (click)="dismiss()" class="btn btn-light" type="button">CLOSE</button>
  </ng-container>
</div>
